module.exports = __webpack_public_path__ + "media/country_flags/au-7e6de413.png";